var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.245,
    height: 26.789,
    viewBox: "0 0 23.245 26.789",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_47",
    "data-name": "Grupo 47",
    transform: "translate(-7.568 1.901)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_12",
    "data-name": "Caminho 12",
    d: "M23.145,4.276c-3.178,3.18-6.343,6.335-9.493,9.5a3.555,3.555,0,1,0,5.019,5.029q5.173-5.152,10.324-10.325a5.763,5.763,0,0,0,1.722-5.271,5.74,5.74,0,0,0-3.886-4.69A5.479,5.479,0,0,0,20.8-.3Q15.18,5.131,9.752,10.759A7.792,7.792,0,0,0,7.8,18.181a8.035,8.035,0,0,0,5.969,6.349A8.2,8.2,0,0,0,22.2,22.26q3.184-3.156,6.341-6.34c.161-.161.3-.342.334-.379l-1.469-1.764a7.621,7.621,0,0,1-.584.77c-2.032,2.045-4.076,4.079-6.111,6.121a6.473,6.473,0,0,1-4.427,2.025,6.316,6.316,0,0,1-5.953-3.724,6.088,6.088,0,0,1,1.223-6.96C15.03,8.454,18.563,4.954,22.1,1.454A3.579,3.579,0,0,1,25.511.406,3.806,3.806,0,0,1,27.5,6.875c-3.394,3.488-6.867,6.9-10.316,10.333-.2.2-.483.456-.717.446a2.211,2.211,0,0,1-1.336-.363,1.671,1.671,0,0,1-.336-1.265,1.971,1.971,0,0,1,.651-.954q4.306-4.335,8.635-8.648c.2-.2.386-.406.553-.582Z",
    transform: "translate(0)",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_13",
    "data-name": "Caminho 13",
    d: "M23.145,4.276l1.49,1.567c-.166.176-.355.383-.553.582q-4.319,4.322-8.635,8.648a1.971,1.971,0,0,0-.651.954,1.671,1.671,0,0,0,.336,1.265,2.211,2.211,0,0,0,1.336.363c.234.01.517-.248.717-.446,3.448-3.435,6.921-6.845,10.316-10.333A3.806,3.806,0,0,0,25.511.406,3.579,3.579,0,0,0,22.1,1.454c-3.533,3.5-7.066,7-10.542,10.556a6.088,6.088,0,0,0-1.223,6.96,6.316,6.316,0,0,0,5.953,3.724,6.473,6.473,0,0,0,4.427-2.025c2.035-2.042,4.079-4.076,6.111-6.121a7.627,7.627,0,0,0,.584-.77l1.469,1.764c-.032.037-.173.217-.334.379q-3.167,3.173-6.341,6.34a8.2,8.2,0,0,1-8.428,2.27A8.035,8.035,0,0,1,7.8,18.182a7.792,7.792,0,0,1,1.949-7.423Q15.163,5.12,20.8-.3a5.479,5.479,0,0,1,6.031-1.178,5.74,5.74,0,0,1,3.886,4.69,5.763,5.763,0,0,1-1.722,5.271Q23.847,13.66,18.671,18.809a3.555,3.555,0,1,1-5.019-5.029C16.8,10.611,19.967,7.456,23.145,4.276Z",
    transform: "translate(0 0)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachIcon);
export default __webpack_public_path__ + "static/media/attach-icon.24af178d6a5503aa54a6c5c281a8134e.svg";
export { ForwardRef as ReactComponent };